import * as React from 'react';
import type { InjectedIntlProps } from 'react-intl';
import { injectIntl } from 'react-intl';
import { FieldBase } from 'view/common/fields/field-base';

import messages from './messages';

export interface Props {
    id: string;
}

export class UnknownField extends React.Component<Props & InjectedIntlProps> {
    render() {
        const { id, intl } = this.props;
        return <FieldBase htmlFor={id} label={intl.formatMessage(messages.unknownField, { id })} />;
    }
}

export default injectIntl(UnknownField);
